export default __webpack_public_path__ + "static/media/Notice_of_Privacy_Practices.e712fcea.pdf";